import styled from '@emotion/styled';

const OptionWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 16px;
    cursor: pointer;
    gap: 10px;
    background: white;
`;

const StyledCheckbox = styled.div`
    width: 18px;
    height: 18px;
    border: ${props => props.isSelected ? '2px solid var(--color-brand-pink-primary)' : '2px solid #c4c4c4'};
    border-radius: 3px;
    background: ${props => props.isSelected ? 'var(--color-brand-pink-primary)' : 'white'};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s;
`;

const PillarIcon = styled.img`
    width: 18px;
    height: 18px;
    flex-shrink: 0;
`;

const OptionLabel = styled.span`
    font-size: 14px;
    color: #222;
    font-weight: 400;
`;

export const CheckboxOption = ({innerProps, label, isSelected, data, selectProps}) => {
    const pillar = selectProps.categoryData?.find(bp => bp.id === data.value);
    return (
        <OptionWrapper {...innerProps}>
            <StyledCheckbox isSelected={isSelected}>
                {isSelected && (
                    <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                        <path d="M1 3.5L3.8 6.5L9 1" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                )}
            </StyledCheckbox>
            {pillar?.icon && (
                <PillarIcon src={pillar.icon} alt={label}/>
            )}
            <OptionLabel>{label}</OptionLabel>
        </OptionWrapper>
    );
};